/**
 * Handle type brightness
 */
export enum TypeBrightness {
  UNKNOWN = -1,
  INACTIVITY = 1,
  PROXIMITY_SENSOR = 2,
}
